import { render } from "./ShopRightSidebarPage.vue?vue&type=template&id=349b6b48&ts=true"
import script from "./ShopRightSidebarPage.vue?vue&type=script&lang=ts"
export * from "./ShopRightSidebarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__